module.exports = __webpack_public_path__ + "img/社会.d46b9168.png";